import { TApiServiceOptions, ApiService } from "../apiService";

import { API } from "../../core/apiurl";
import { TBrandingDetailsResponse, TBrandingFormData } from "./branding.types";
import { authenticatedApiService } from "../apiservice.auth";

const apiService = new ApiService();

// Service class for branding details
class BrandingService {
  // methods
  getBrandingList(options?: TApiServiceOptions) {
    return authenticatedApiService.get<TBrandingDetailsResponse>(
      API.branding,
      options,
    );
  }
  // add branding
  addBranding(payload: FormData, options?: TApiServiceOptions) {
    return authenticatedApiService.post<TBrandingFormData>(
      API.branding,
      payload,
      options,
    );
  }

  //update branding
  updateBranding(payload: FormData, options?: TApiServiceOptions) {
    return authenticatedApiService.put<TBrandingFormData>(
      API.branding,
      payload,
      options,
    );
  }

  // get theme
  getTheme(options?: TApiServiceOptions) {
    return apiService.get<TBrandingDetailsResponse>(API.theme, options);
  }
}

export const brandingService = new BrandingService();
